import { ActionLog } from '../../types'

export type InitialPagination = {
    currentPage: Number
    perPage: Number
    total: Number
    from: Number
    to: Number
}

export type ActionLogsState = {
    logs: ActionLog[]
    selectedLog: ActionLog | null
    search: string
    pagination: InitialPagination
}

const initialPagination: InitialPagination = {
    currentPage: 0,
    perPage: 0,
    total: 0,
    from: 0,
    to: 0,
}

const initialState: ActionLogsState = {
    logs: [],
    selectedLog: null,
    search: '',
    pagination: {
        ...initialPagination,
    },
}

export default initialState
